import { JobPostingCard } from "../../page-components/Jobs"
import React from "react"
import { ArticleContentComponentContainer } from "../utils"

export const ArticleJobPosting = ({ job_posting }) => {
  return (
    <ArticleContentComponentContainer
      {...{
        custom_classes: "mb-6",
        attributes: { "data-nosnippet": true },
      }}
    >
      <div className="ad-wrapper" style={{ maxWidth: "100%" }}>
        <JobPostingCard {...{ job: job_posting, in_article: true }} />
        <div className="ad-disclaimer mt-1">Anzeige</div>
      </div>
    </ArticleContentComponentContainer>
  )
}
